/* eslint-disable max-lines */
import { Divider, Typography } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer/Drawer';
import Grid from '@material-ui/core/Grid';
import Radio from '@material-ui/core/Radio/Radio';
import DescriptionProduct from 'components/Shared/DescriptionProduct';
import { SvgIcon } from 'components/Shared/SvgIcon';
import TextAreaCopyToClipboard from 'components/Shared/TextAreaCopyClipboard';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import React, { Component } from 'react';
import * as rxjsOperators from 'rxjs-operators';
import { scriptElementsService } from 'services/elementsService';
import MonitorIcon from 'mdi-react/MonitorIcon';
import CellphoneIcon from 'mdi-react/CellphoneIcon';
import Card from './Card';
import { analyticsG4, enFeatures } from 'services/AnalyticsG4';
import { CDN_URL } from 'settings';

interface IState {
  selectedProduct: IProductNew;
  errorCover: boolean;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  '@keyframes toLeft': {
    from: {
      transform: 'translate(448px)'
    },
    to: {
      transform: 'translate(0)'
    }
  },
  snackbar: {
    marginBottom: 16,
    maxWidth: 'none',
    boxShadow: 'none',
    backgroundColor: '#ffa000',
    padding: '0 0 0 18px',
    color: '#FFF',
    fontWeight: 500
  },
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  infoIcon: {
    marginRight: 15,
    fill: '#FFF'
  },
  drawerPaper: {
    transform: 'translate(448px)',
    animation: 'toLeft 0.3s ease-in-out 0.5s forwards',
    fontFamily: 'Lato',
    width: 1178,
    '@media screen and (max-width: 1178px)': {
      width: '100%'
    }
  },
  drawerOptions: {
    overflow: 'scroll',
    backgroundColor: '#fff',
    height: '100%',
    padding: '20px 30px',
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: 10
    }
  },
  titleClose: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    paddingTop: 10,
    justifyContent: 'center',
    width: '100%'
  },

  closeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },

  h2: {
    fontWeight: 'bold',
    color: theme.variables.colors['primaryColor'],
    margin: 0
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 35,
    height: 35,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'center',
    minWidth: 35,
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  },
  titleScript: {
    fontWeight: 'bold'
  },
  buttonContinue: {
    marginTop: 50,
    width: '100%',
    textAlign: 'start'
  },
  link: {
    color: '#0D47A1',
    fontWeight: 600
  },
  button: {
    fontWeight: 400,
    backgroundColor: '#009358',
    color: '#fff',
    width: '100%',
    padding: 10,
    marginBottom: 10
  },
  plataformContainer: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'column nowrap'
  },
  imageNoErrorCover: {
    width: 280
  },
  imageThankYou: {
    width: 240
  },
  radioContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fill: theme.variables.colors['primaryColor']
    }
  },
  span: {
    fontSize: '1rem',
    color: '#37474F',
    margin: '0 0 24px 0'
  },
  label: {
    width: 300,
    fontSize: '1rem',
    color: '#37474F'
  },
  containerPlatform: {
    display: 'flex',
    '& svg': {
      marginTop: 4,
      fill: '#546E7A'
    },
    '& p': {
      margin: 0,
      color: '#546E7A'
    }
  },
  divider: {
    margin: '24px 0'
  },
  descriptionContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  }
}))
export default class ElementsActions extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { selectedProduct: null, errorCover: false };
  }

  componentDidMount() {
    scriptElementsService
      .getSelectedProduct()
      .pipe(
        rxjsOperators.tap(selectedProduct => {
          this.setState({ selectedProduct });
        }),
        rxjsOperators.filter(selectedProduct => !!selectedProduct),
        rxjsOperators.bindComponent(this)
      )
      .subscribe(selectedProduct => {
        this.setState({ selectedProduct });
      });
  }

  onClose = () => {
    scriptElementsService.setSelectedProduct(null);
  };

  setErrorCover = () => {
    const { errorCover } = this.state;
    this.setState({ errorCover: !errorCover });
  };

  render(): JSX.Element {
    const { classes } = this.props;
    const { selectedProduct, errorCover } = this.state;
    if (!selectedProduct) {
      return null;
    }
    analyticsG4.sendPageView({ feature: enFeatures.CHECKOUT_ELEMENTS });
    const script = `      <div id="elements"></div>
      <script src="${CDN_URL}/sun/bridge/bridge.js" async type="module"></script>
      <script>
        (function () {
          const load = function () {
              window.Eduzz.Checkout.init({
                contentId: "${selectedProduct?.hashId || selectedProduct?.id}",
                target: "elements",
                errorCover: ${errorCover}
              });
          }
          if (document.readyState === 'complete') {
              load();
              return;
          }
          window.addEventListener('load', load);
        })();
      </script>`;

    return (
      <Drawer
        anchor="right"
        open={!!selectedProduct}
        ModalProps={{
          classes: { root: classes.removeBackdrop },
          disableBackdropClick: true,
          onBackdropClick: this.onClose
        }}
        PaperProps={{ classes: { root: classes.drawerPaper } }}
      >
        <div className={classes.drawerOptions}>
          <div className={classes.titleClose}>
            <div className={classes.closeContainer}>
              <h2 className={classes.h2}>Checkout Elements</h2>

              <span className={classes.closeButton} onClick={this.onClose}>
                <SvgIcon name={'closeIcon'} />
              </span>
            </div>
            <div className={classes.descriptionContainer}>
              <DescriptionProduct
                title={selectedProduct.name}
                productId={selectedProduct.id}
                image={selectedProduct.image}
              />
            </div>
          </div>
          <Divider className={classes.divider} />
          <div>
            <Card
              text="Para configurar o Elements você precisa ter uma página de vendas. Caso ainda não tenha, você pode criar
              uma através do Órbit Pages."
              link="https://app.orbitpag.es/eduzz-sun"
              illustration={<SvgIcon name="illustrationOrbit" />}
              logo={<SvgIcon name="orbitPages" />}
            />
          </div>

          <Grid style={{ marginBottom: 24 }}>
            <p className={classes.span}>
              <b>1</b> - Alguns eventos da página podem aparecer somente no <b>Checkout Elements</b> ou na{' '}
              <b>Página de vendas</b>. Abaixo você pode escolher o que deseja.
            </p>
            <Grid container alignItems="center" direction="column">
              <Grid container justify="space-around" style={{ width: '85%' }}>
                <Grid item>
                  <Grid className={classes.card} item>
                    <img
                      width="284"
                      alt="Imagem de exemplo de como ficaria com o error cover no checkout"
                      src="https://cdn.eduzzcdn.com/sun/assets/img/launch.jpg"
                    />
                  </Grid>
                  <Grid item className={classes.radioContainer}>
                    <Radio checked={!errorCover} onChange={this.setErrorCover} />
                    <Typography className={classes.label}>
                      Quero que esses eventos apareçam somente no formulário do Checkout Elements
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item>
                  <Grid className={classes.card} style={{ height: 355 }} item>
                    <img
                      width="280"
                      alt="Imagem de exemplo de como ficaria sem o error cover no checkout"
                      src="https://cdn.eduzzcdn.com/sun/assets/img/erros-pagina-de-vendas.jpg"
                    />
                  </Grid>
                  <Grid item className={classes.radioContainer}>
                    <Radio checked={errorCover} onChange={this.setErrorCover} />
                    <Typography className={classes.label}>
                      Quero que esses eventos apareçam na página de vendas
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid style={{ marginBottom: 24 }}>
            <p className={classes.span}>
              <b>2</b> - Agora copie o script abaixo e adicione no body do seu site.
            </p>
            <Grid container justify="center" style={{ flexFlow: 'column', alignItems: 'center' }}>
              <TextAreaCopyToClipboard
                width={650}
                height={400}
                text={script}
                onClick={() => analyticsG4.sendSuccess(enFeatures.CHECKOUT_ELEMENTS)}
              />
              <p className={classes.span}>
                OBS: Para mover o seu checkout de posição é preciso alterar a <b>{`<div id="elements"></div>`}</b> de
                lugar no seu código.
              </p>
            </Grid>
          </Grid>

          <Grid style={{ marginBottom: 24 }}>
            <p className={classes.span}>
              <b>3</b> - Lembrando que o Elements já possui uma página de obrigado, pensada para melhor atender você,
              mas se desejado você pode configurar sua própria página de obrigado através do Órbita.
            </p>
            <Grid container alignItems="center" direction="column">
              <Grid container justify="space-around" style={{ width: '85%' }}>
                <Grid className={classes.card}>
                  <img
                    width="350"
                    alt="Página de obrigado do Elements"
                    src="https://cdn.eduzzcdn.com/sun/assets/img/boleto.jpg"
                  />
                </Grid>
              </Grid>
              <p className={classes.span}>
                <b>Página de Obrigado elements</b>
              </p>
            </Grid>
            <p className={classes.span}>
              Para configurar sua própria página de obrigado, vá nas configurações avançadas do seu produto no Órbita e
              adicione a URL das suas páginas.
            </p>
            <Grid container justify="center">
              <Grid className={classes.card}>
                <img width="610" src="https://cdn.eduzzcdn.com/sun/assets/img/thankyouUrl.jpg" />
              </Grid>
            </Grid>
            <p className={classes.span}>Depois é só ir até sua página de obrigado e adicionar o script abaixo.</p>
            <Grid container justify="center">
              <TextAreaCopyToClipboard
                width={555}
                height={88}
                text='&#9;<script src="https://cdn.eduzzcdn.com/sun/thankyou/thankyou.js"></script>'
              />
            </Grid>
          </Grid>
          <Grid>
            <p className={classes.span}>
              <b>4</b> - Por ultimo ao configurar o elements temos algumas indicações de tamanho para melhor
              usabilidade, fique atento a isso.
            </p>
            <Grid container justify="center">
              <Grid container justify="space-around" style={{ width: '85%', marginBottom: 20 }}>
                <Grid item>
                  <Grid className={classes.card} item>
                    <img
                      width="290"
                      alt="Imagem de exemplo de como ficaria sem o error cover no checkout"
                      src="https://cdn.eduzzcdn.com/sun/assets/img/desktop.jpg"
                    />
                  </Grid>
                  <Grid item className={classes.containerPlatform}>
                    <MonitorIcon />
                    <Grid item style={{ marginLeft: 16 }}>
                      <p>Desktop:</p>
                      <p>Largura mínima de 700 px</p>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item>
                  <Grid className={classes.card} item>
                    <img
                      width="159"
                      alt="Imagem de exemplo de como ficaria com o error cover no checkout"
                      src="https://cdn.eduzzcdn.com/sun/assets/img/mobile.jpg"
                    />
                  </Grid>
                  <Grid item className={classes.containerPlatform}>
                    <CellphoneIcon />
                    <Grid item style={{ marginLeft: 16 }}>
                      <p>Mobile:</p>
                      <p>Largura de 100% da página</p>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    );
  }
}
